import { useState } from 'react'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { useIntl, FormattedMessage } from 'react-intl'
import TextArea from 'components/shared/Input/textarea'
import { setSpecialRequests } from 'store/accommodation-slice'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'store/hooks'
import ExpandableBox from 'components/shared/ExpandableBox'
import { SpecialRequestsSection } from './styles'

const SpecialRequests = () => {
    const { formatMessage } = useIntl()
    const dispatch = useDispatch()

    const { specialRequests } = useAppSelector((state) => state.accommodation)

    const [isExpandableBoxOpen, setIsExpandableBoxOpen] = useState(false)

    const handleInputChange = (value: string) => {
        dispatch(setSpecialRequests(value))
    }

    return (
        <SpecialRequestsSection>
            <ExpandableBox
                title={formatMessage({
                    defaultMessage: 'Dodatkowe uwagi i życzenia',
                    id: 'accommodation.special_requests.trigger_label',
                })}
                color="secondary_500"
                isBoxOpen={isExpandableBoxOpen}
                setIsBoxOpen={setIsExpandableBoxOpen}
                testIdPrefix="accommo-trigger-additional-requests"
            >
                <Box isFullWidth={true} mt={[8, 16]}>
                    <Text variant="heading2" mb={[16, 24]}>
                        <FormattedMessage
                            id="accommodation.special_requests.heading"
                            defaultMessage="Czy możemy Ci jeszcze w czymś pomóc?"
                        />
                    </Text>
                    <Text
                        variant="bodySmall"
                        mb={[16, 24]}
                        color="grayscale_700"
                    >
                        <FormattedMessage
                            id="accommodation.special_requests.info"
                            defaultMessage="Daj nam znać! Dołożymy wszelkich starań, aby Twój pobyt u nas był wyjątkowy."
                        />
                    </Text>
                    <TextArea
                        hasNoMaxWidth={true}
                        id="specialRequests"
                        maxCharacters={500}
                        placeholder={formatMessage({
                            id: 'accommodation.special_requests.textarea_placeholder',
                            defaultMessage: 'Opisz swoje potrzeby....',
                        })}
                        onChange={handleInputChange}
                        valueProp={specialRequests || ''}
                        testId="accommo-field-additional-requests"
                    />
                </Box>
            </ExpandableBox>
        </SpecialRequestsSection>
    )
}

export default SpecialRequests
